import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import LoaderBounce from 'components/loaders/LoaderBounce';
import CandidateContent from './CandidateContent';
import CompareContent from './CompareContent';
import useStyles from './styles';

const MultipleCardsMode = observer(({
    className = '', getUserInfo, company, isLoading, isLoadingAudition,
    user, opportunitySlug, audition, candidatesInfo,
    loadCandidatePosts, propPublic, authorizeGuest, gradeableCard,
    addCandidateComment, loadGradeQuestion, gradeFunction, selectedCandidateUuid,
    getAuditionQuestionResults, hideCandidateDetails, onChangePublicUser,
    getAuditionScreeningQuestionResults: getAuditionScreeningResults
}) => {
    const [isCompare, setIsCompare] = useState(false);

    const classes = useStyles();

    const onChangeUser = (uuid) => {
        setIsCompare(false);
        onChangePublicUser(uuid);
    };

    const toggleCompareMode = () => {
        setIsCompare(!isCompare);
    };

    if (isLoading) {
        return (
            <div className="u-txt--center u-pdn--tx10 u-pdn--bx10">
                <LoaderBounce />
            </div>
        );
    }
    const candidates = Object.values(candidatesInfo).map(({ candidate }) => candidate);
    const multiProps = {
        isCompare,
        candidates,
        onChangePublicUser: onChangeUser,
        selectedCandidateUuid,
        toggleCompareMode
    };

    return (
        <div className={clsx(classes.wrapper, className)}>
            {
                isCompare ? (
                    <CompareContent
                        multiProps={multiProps}
                        audition={audition}
                        gradeableCard={gradeableCard}
                        handleClose={toggleCompareMode}
                        candidatesInfo={candidatesInfo}
                        opportunitySlug={opportunitySlug}
                        hideCandidateDetails={hideCandidateDetails}
                        candidatesIdsToCompare={Object.keys(candidatesInfo).reduce((prevObj, key) => ({ ...prevObj, [key]: candidatesInfo[key].opportunities[0].columns[0].userAudition.uuid }), {})}
                    />
                ) : (
                    <CandidateContent
                        {...{
                            user,
                            audition,
                            company,
                            propPublic,
                            getUserInfo,
                            opportunitySlug,
                            hideCandidateDetails,
                            loadCandidatePosts,
                            authorizeGuest,
                            gradeFunction,
                            addCandidateComment,
                            loadGradeQuestion,
                            gradeableCard,
                            isLoadingAudition,
                            getAuditionQuestionResults,
                            getAuditionScreeningResults,
                            multiProps
                        }}
                    />
                )
            }
            {/* <div className={clsx(classes.contentPanel, isCompare && 'u-pdn--x0')} /> */}
        </div>
    );
});

export default withRouter(MultipleCardsMode);
